import { timeData as v } from "./index106.mjs";
function y(r, u) {
  for (var e = "", i = 0; i < r.length; i++) {
    var c = r.charAt(i);
    if (c === "j") {
      for (var f = 0; i + 1 < r.length && r.charAt(i + 1) === c; )
        f++, i++;
      var g = 1 + (f & 1), h = f < 2 ? 1 : 3 + (f >> 1), l = "a", a = o(u);
      for ((a == "H" || a == "k") && (h = 0); h-- > 0; )
        e += l;
      for (; g-- > 0; )
        e = a + e;
    } else c === "J" ? e += "H" : e += c;
  }
  return e;
}
function o(r) {
  var u = r.hourCycle;
  if (u === void 0 && // @ts-ignore hourCycle(s) is not identified yet
  r.hourCycles && // @ts-ignore
  r.hourCycles.length && (u = r.hourCycles[0]), u)
    switch (u) {
      case "h24":
        return "k";
      case "h23":
        return "H";
      case "h12":
        return "h";
      case "h11":
        return "K";
      default:
        throw new Error("Invalid hourCycle");
    }
  var e = r.language, i;
  e !== "root" && (i = r.maximize().region);
  var c = v[i || ""] || v[e || ""] || v["".concat(e, "-001")] || v["001"];
  return c[0];
}
export {
  y as getBestPattern
};
